const tableData = {
    headers: {
        number: '№\n п/п',
        name: 'Наименование мероприятия, дата',
        type: 'Форма участия (индивидуальное выступление, участие в команде и т.п.)',
        result: 'Результат'
    },
    headersIndividPlan: {
        number: '№\n п/п',
        name: 'Задачи по основным видам деятельности',
        type: 'Срок выполнения',
        result: 'Отметка о выполнении'
    },
    headersGrade: {
        number: '№\n п/п',
        name: 'Наименование практики, семестр',
        type: 'Место прохождения',
        result: 'Оценка'
    },
    secondTableData: [
        {number: ' ', text: ' ', page: 'Стр.'},
        {number: '1.', text: 'Лист представления', page: '3'},
        {number: '2.', text: 'Портфолио достижений и работ', page: '4'},
        {number: ' ', text: 'Раздел 1. Образовательная деятельность ', page: '4-6'},
        {number: ' ', text: 'Раздел 2. Научная (научно-исследовательская) деятельность', page: '7'},
        {number: ' ', text: 'Раздел 3. Прохождение практик', page: '7'},
        {number: ' ', text: 'Раздел 4. Дополнительные личные достижения', page: '7'},

    ],
    thirdTableData: [
        {years: 'Период\n (гг.-гг.)', institution: 'Наименование образовательного\n учреждения, город', field: 'Специальность'},
        {years: '2002-2009', institution: 'МОУ ЛСТУ АЛОВоЛАО', field: 'testtesttest'},
        {years: '2009-2013', institution: 'УОР Пенза', field: 'testtesttest'}
    ],
    fifthTable: [
        {
            number: '№\n п/п',
            name: 'Наименование мероприятия, дата',
            type: 'Форма участия (индивидуальное выступление, участие в команде и т.п.)',
            result: 'Результат'
        },
        {name: 'Эффективность', type: 'Форма уча', result: 'Результат'},
        {name: 'Подготовка', type: 'Форма уча', result: '132123123123123'},
        {name: 'Управление', type: 'Форма уча', result: 'Результат'},
    ],
    IndividPlanTable: [
        {
            number: '№\n п/п',
            name: 'Задачи по основным видам деятельности',
            type: 'Срок выполнения',
            result: 'Отметка о выполнении',
        },
        {name: 'Эффективность', type: 'Форма уча', result: 'Результат', },
        {name: 'Подготовка', type: 'Форма уча', result: '132123123123123', },
        {name: 'Управление', type: 'Форма уча', result: 'Результат', },
        {name: 'Управление', type: 'Форма уча', result: 'Результат', },
    ],
    sixthTable: [
        {name: 'Учебная практика, 6 семестр.', type: 'ВА ПФ МТО ПРЕ КАМ', result: 'хорошо'},
        {name: 'Боевые стрельбы, 6 семестр.', type: 'ПФ ВА МТО', result: 'ЗаЧтЕнО'},
        {name: 'Управление людьми', type: 'в/ч 32755', result: 'хорошо'},
    ],
    seventhTable: [
        {name: 'Эффективность', type: 'Форма уча', result: 'Результат'},
        {name: 'Подготовка', type: 'Форма уча', result: '132123123123123'},
        {name: 'Управление', type: 'Форма уча', result: 'Результат'},
    ],
    eighthTable: [
        {
            number: '№\n п/п',
            name: 'Наименование мероприятия, дата',
            type: 'Форма участия (индивидуальное выступление, участие в команде и т.п.)',
            result: 'Результат'
        },
        {name: 'Эффективность', type: 'Форма уча', result: 'Результат'},
        {name: 'Подготовка', type: 'Форма уча', result: '132123123123123'},
        {name: 'Управление', type: 'Форма уча', result: 'Результат'},
    ],
    hugeTable: [
        [
            {name: 'Информатика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Введение в специальность', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
            {name: 'История', preGrade: ' ', grade: 'хорошо'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Физическая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Иностранный язык', preGrade: ' ', grade: 'хорошо'},
            {name: 'Начертательная геометрия', preGrade: ' ', grade: 'удовлет.'},
            {name: 'Химия', preGrade: ' ', grade: 'хорошо'},
        ],
        [
            {name: 'Высшая математика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Информатика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
            {name: 'История', preGrade: ' ', grade: 'ОТЛИЧНО'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Физическая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Иностранный язык', preGrade: ' ', grade: 'хорошо'},
            {name: 'Начертательная геометрия', preGrade: ' ', grade: 'удовлет.'},
            {name: 'Химия', preGrade: ' ', grade: 'хорошо'},
            {name: 'Культурология', preGrade: ' ', grade: 'хорошо'},
            {name: 'Химия', preGrade: ' ', grade: 'хорошо'},
        ],
        [
            {name: 'Физика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Теоретическая механика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
            {name: 'История', preGrade: ' ', grade: 'хорошо'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Физическая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Тактика', preGrade: ' ', grade: 'хорошо'},
        ],
        [
            {name: 'Военная история ', preGrade: ' ', grade: 'хорошо'},
            {name: 'Сопротивление материалов', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
            {name: 'Технология конструкционных материалов ', preGrade: ' ', grade: 'ОТЛИЧНО'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Физическая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Иностранный язык', preGrade: ' ', grade: 'хорошо'},
            {name: 'Начертательная геометрия', preGrade: ' ', grade: 'удовлет.'},
            {name: 'Материаловедение', preGrade: ' ', grade: 'хорошо'},
            {name: 'Культурология', preGrade: ' ', grade: 'хорошо'},
            {name: 'Метрология, стандартизация и сертификация', preGrade: ' ', grade: 'хорошо'},
        ],
        [
            {name: 'Политология', preGrade: ' ', grade: 'хорошо'},
            {name: 'Электротехника и электроника', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
            {name: 'История', preGrade: ' ', grade: 'хорошо'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Физическая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Тактика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Материаловедение', preGrade: ' ', grade: 'хорошо'},
            {name: 'Философия', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
        ],
        [
            {name: 'Политология', preGrade: ' ', grade: 'хорошо'},
            {name: 'Электротехника и электроника', preGrade: ' ', grade: 'хорошо'},
            {name: 'Физические основы устройства ствольных и ракетных систем', preGrade: ' ', grade: 'удовлет.'},
            {name: 'История', preGrade: ' ', grade: 'хорошо'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Тактика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Материаловедение', preGrade: ' ', grade: 'хорошо'},
            {name: 'Управление в технических системах', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
        ],
        [
            {name: 'Физика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Теоретическая механика', preGrade: ' ', grade: 'хорошо'},
            {name: 'Высшая математика', preGrade: ' ', grade: 'удовлет.'},
            {name: 'История', preGrade: ' ', grade: 'хорошо'},
            {name: 'Строевая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Физическая подготовка', preGrade: ' ', grade: 'ЗАЧТЕНО'},
            {name: 'Тактика', preGrade: ' ', grade: 'хорошо'},
        ],
    ]
};

export default tableData;